<template>
  <section>
    <div class="status">
      <h2>{{ title }}</h2>
      <a v-if="isEditable && isAddValueAllowed" class="add add_expand"
         :class="{ open: addItemOpened && isAddValueAllowed }" @click.stop="_toggleAddItem"
         :title="$gettext('Přidat hodnotu')" v-translate>Přidat hodnotu</a>

      <select-box
          :id="'editable_' + sortingKey"
          :options="editableOptions"
          v-model="editable"
          :disabled="!isEditable"
          @input="_editableChanged"
          :omit-label="true"
          v-if="this.settingsObject"/>
    </div>

    <div class="filter expand_content" :class="{ open: addItemOpened && isAddValueAllowed }">
      <div class="field_left">
        <select-box
            :id="'new_value_' + sortingKey"
            :options="availableValueOptions"
            v-model="selectedItem">
          {{ valueLabel }}
        </select-box>
      </div>

      <div class="field_right">
        <p class="field">
          <input class="btn" type="submit" @click.stop.prevent="_addNewValue" :value="$gettext('Přidat')">
        </p>
      </div>
    </div>

    <table class="vypis vypis_detail">
      <tbody :class="['sortable_' + sortingKey, {sortable: isEditable, 'ui-sortable': isEditable}]">
      <tr :class="['sorted_' + sortingKey, {'ui-sortable-handle': isEditable}]" v-for="(value, index) in values"
          :key="'line_' + sortingKey + '_' + value.type" :rowvalue="value.type">
        <td class="no_padding drag_drop"><span/></td>
        <td class="no_padding checkbox">
          <input
              :id="'default_item_' + sortingKey + '_' + index"
              @click.stop="_defaultValueChanged(value.type)"
              :name="'default_' + sortingKey"
              type="radio"
              :checked="value.type === settingsObject.default"
              :disabled="!isEditable"
          >
          <label :for="'default_item_' + sortingKey + '_' + index"
                 :title="$gettext('Nastavit jako výchozí')">{{ $gettext('Výchozí') }}</label>
        </td>
        <td data-th="Hodnota" class="first_data">
          <div>{{ _getValueName(value.type) }}:
            <select-box v-if="imageTypeOptions[value.type]"
                :id="'value_' + sortingKey + '_' + value.type"
                :options="imageTypeOptions[value.type]"
                v-model="imageTypeValue[value.type]"
                @input="_typeValueChanged(value.type)"
                :disabled="!isEditable"
            >
            </select-box>
          </div>
        </td>
        <td/>

        <td class="no_padding edit" v-if="isEditable">
          <div class="edit_inner">
            <a class="btn btn_action btn_delete" :title="$gettext('Smazat')"
               @click.stop="_removeValue(value.type, index)">{{ $gettext('Smazat') }}</a>
          </div>
        </td>
      </tr>
      </tbody>
      <tr v-if="values.length === 0">
        <td colspan="8" v-translate>Nastavení se neuplatňuje.</td>
      </tr>
    </table>
  </section>
</template>

<script>

export default {
  name: "ImageSizeSettingsTable",
  props: {
    isEditable: Boolean,
    title: String,
    fixedValues: Array,
    settingsObject: Object,
    valueLabel: String,
    sortingKey: String,
    nameTransformFunction: Function,
    typeOptions: Object,
  },
  mounted() {
    if (this.isEditable) {
      $('.sortable_' + this.sortingKey).sortable({
        stop: this._valuesSorted
      });
    }
    this.setAvailableOptions();
    this.setDefaultValues();
  },
  data() {
    return {
      addItemOpened: false,
      editable: this.settingsObject ? this.settingsObject.editable : false,
      selectedItem: null,
      imageTypeOptions: {},
      imageTypeValue: {},
    }
  },
  methods: {
    hasSelectableValues() {
      return !!this.fixedValues;
    },
    _toggleAddItem() {
      this.addItemOpened = !this.addItemOpened;
    },
    _editableChanged() {
      this.$emit('editableChanged', this.editable);
    },
    _addNewValue() {
      if (this.selectedItem !== null) {
        if(this.imageTypeOptions[this.selectedItem].length > 0)
        {
          this.imageTypeValue[this.selectedItem] = this.imageTypeOptions[this.selectedItem][0].id;
        }
        this.setAvailableOptions();
        this.$emit('addValue', {type: this.selectedItem, value: this.imageTypeValue[this.selectedItem]});
        this.selectedItem = null;
      }
      this._resetDefault();
    },
    _defaultValueChanged(value) {
      this.$emit('defaultValueChanged', value);
    },
    _typeValueChanged(type){
      this.$emit('typeValueChanged', {type: type, value: this.imageTypeValue[type]})
    },
    _removeValue(value, index) {
      delete this.imageTypeValue[value];
      this.setAvailableOptions();
      this.$emit('removeValueByIndex', index);
      this.$emit('removeValue', value);
      this._resetDefault();
    },
    _resetDefault(){
      if(Object.keys(this.imageTypeValue).length === 1){
        let key = Object.keys(this.imageTypeValue)[0];
        this._defaultValueChanged(key);
      }
    },
    _valuesSorted() {
      const newValues = [];

      $('.sorted_' + this.sortingKey).each((el, x) => {
        let type = $(x).attr('rowvalue');
        newValues.push({type: type, value: this.imageTypeValue[type]});
      });

      this.$emit('valuesSorted', newValues);
    },
    _getValueName(value) {
      return this.nameTransformFunction ? this.$gettext(this.nameTransformFunction(value)) : value;
    },
    setAvailableOptions() {
      let selectedItems = [];
      for (const [selectedKey, selectedValue] of Object.entries(this.imageTypeValue)) {
        selectedItems.push(selectedValue);
      }
      this.imageTypeOptions = {};
      this.fixedValues.forEach(item => {
        this.imageTypeOptions[item] = [];
        for (const [key, value] of Object.entries(this.typeOptions)) {
          if (selectedItems.includes(key) && this.imageTypeValue[item] !== key) {
            continue;
          }
          this.imageTypeOptions[item].push({text: value, id: key});
        }
      });
    },
    setDefaultValues(){
      if(this.settingsObject){
       this.settingsObject.values.forEach(item => {
         this.imageTypeValue[item.type] = item.value;
       });
      }
    }
  },
  computed: {
    values() {
      return this.settingsObject ? this.settingsObject.values : [];
    },
    editableOptions() {
      return [{
        id: false,
        text: this.$gettext('Zakázat změny')
      }, {
        id: true,
        text: this.$gettext('Povolit změny')
      }];
    },
    availableValues() {
      let keys = this.values.map(item => item.type);
      return this.fixedValues ? this.fixedValues.filter((value) => {
        return !keys.includes(value);
      }) : [];
    },
    availableValueOptions() {
      const values = [];

      this.availableValues.forEach((value) => {
        values.push({
          id: value,
          text: this._getValueName(value)
        });
      });

      if (this.availableValues.length > 0 && !this.availableValues.includes(this.selectedItem)) {
        this.selectedItem = this.availableValues[0];
      }

      return values;
    },
    isAddValueAllowed() {
      return !this.hasSelectableValues() || (this.hasSelectableValues() && this.availableValues.length > 0);
    }
  },
  watch: {
    imageTypeValue() {
      this.setAvailableOptions();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/ImageSizeSettingsTable.vue